const els = {
    $list: ($tabs) => $tabs.find('[data-tab-list]'),
    $buttons: ($tabs) => $tabs.find('[data-tab-list-button]'),
    $panelSet: ($tabs) => $tabs.find('[data-tab-panels]'),
    $panels: ($tabs) => $tabs.find('[data-tab-panel]'),
};

const initializeTabs = (tabs) => {

    const $tabs = $(tabs);
    const $panels = els.$panels($tabs);
    const $buttons = els.$buttons($tabs);

    $panels.first().attr('data-active', '1');

    $buttons.on('click', (event) => {
        const $button = $(event.currentTarget);
        const $otherButtons = $buttons.not($button);

        const index = $button.index();

        const $panel = $panels.eq(index);
        const $otherPanels = $panels.not($panel);

        $otherButtons.attr('data-active', '0');
        $button.attr('data-active', '1');

        $otherPanels.attr('data-active', '0');
        $panel.attr('data-active', '1');
    });
};

const initialize = () => {
    $('[data-tabs]').each((_, element) => {
        initializeTabs(element);
    });
};

export default {
    initialize,
};

